import { render, staticRenderFns } from "./DepositCharge.vue?vue&type=template&id=7cb98d74&"
import script from "./DepositCharge.vue?vue&type=script&lang=js&"
export * from "./DepositCharge.vue?vue&type=script&lang=js&"
import style0 from "./DepositCharge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DepositCharge.vue"
export default component.exports